module.exports = __webpack_public_path__ + "static/media/star_checked.e65dfd1c.svg";